import { Typography } from "@material-ui/core";
import { Grid, Paper } from "@mui/material";
import isoCountries from "i18n-iso-countries";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import CommonUtil from "../../Util/CommonUtils";
import { REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT } from "../../actions/EndPoints";
import USA_visLogo from "../../assets/USA_Images/login_images/App-logo.svg";
import CustomDateTimePicker1 from "../../components/CustomInputs/CustomDateTimePicker1";
import CustomPhone1 from "../../components/CustomInputs/CustomPhone1";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import { getListSettingsById } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { getCompanyById } from "../../slices/Company/CompanySlice";
import { visitorUpdate } from "../../slices/Invitations/InvitationsSlice";
import { validateVisitorImage } from "../../slices/VisitorDocuments/VisitorDocumentSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import ConfirmUploadPhoto from "../Employee/ConfirmUploadPhoto";

function ConfirmVisitV2() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const location = useLocation();
  const [paramid, setParamid] = useState("");
  const [code, setCode] = useState("");
  const [validatelist, setValidatelist] = useState([]);
  const [profile, setProfile] = React.useState();
  const [profileImage, setProfileImage] = React.useState();
  const [checkList, setCheckList] = useState([]);
  const [visitorsId, setVisitorsId] = useState("");
  const [phoneInput, setPhoneInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadpic, setUploadPic] = useState(false);
  const [visitModeWalk, setVisitModeWalk] = useState(true);
  const [dateFormat, setDateFormat] = useState("");
  const [profilePhotEnable, setProfilePhotoEnable] = useState("");
  const [ndaEnabled, setNdaEnabled] = useState(false);
  const [safetyInstructionEnabled, setSafetyInstructionEnabled] = useState(
    false,
  );
  const [profilePhotoMandatory, setProfilePhotoMandatory] = useState("");
  const [confirmProfilePhoto, setConfirmProfilePhoto] = useState(
    "confirmProfilePhoto",
  );
  const [companyId, setCompanyId] = useState("");
  const [phoneNumberCheck, setPhoneNumberCheck] = useState("");
  const [companyData, setCompanyData] = useState("");
  const { darkMode, setDarkMode } = useContext(ThemeContext);
  const [invitationNDA, setInvitationNDA] = useState(false);
  const [walkInRegistrationNDA, setWalkINRegistrationNDA] = useState(false);
  const [status, setStatus] = useState("");
  const [resetTrigger, setResetTrigger] = useState(0);

  const [payload, setPayload] = useState({
    id: "",
    code: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    profilePhoto: "",
    phoneCountryCode: "",
    visitorCompanyName: "",
    hostName: "",
    visitorId: "",
    scheduledStartDate: "",
    scheduledEndDate: "",
    visitMode: "",
  });

  const [error, setError] = useState({
    id: false,
    code: false,
    firstName: false,
    lastName: false,
    email: false,
    phoneNumber: false,
    visitorCompanyName: false,
    hostName: false,
    profilePhoto: false,
    visitMode: false,
  });

  useEffect(() => {
    setDarkMode(false);
    setIsLoading(true);
    loadData();
  }, []);

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setError({
      ...error,
      [name]: false,
    });
  };
  const inputStyle = {
    color: darkMode ? "#fff" : "#000",
  };

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPhoneInput(value);
    setPayload({
      ...payload,
      phoneCountryCode: "+" + data.dialCode,
      phoneNumber: value.toString().replace(data.dialCode, ""),
    });
    setError({ phoneNumber: false });
  };

  const loadData = () => {
    var urlValue = window.location.href;
    var url = new URL(urlValue);
    var code = url.searchParams.get("code");
    setCode(code);
    httpCommon
      .unsecuredAxios()
      .get("/web/visit/validate/" + code)
      .then(async (res) => {
        const data = res.data;
        if (data.code === "CVSI0000") {
          setValidatelist(data.data.checkListItem);
          setParamid(data.data.Visit.id);
          setStatus(data.data.Visit.status);
          setCompanyId(data.data.Visit.companyId);
          if (data.data.Visit.companyId) {
            const settings = await ndaSettings(data.data.Visit.companyId);
            if (settings.code === "CVAI0000") {
              switch (data.data.Visit.visitMode) {
                case "INVITATION":
                  setNdaEnabled(settings.data.invitationNDA);
                  setSafetyInstructionEnabled(
                    settings.data.invitationSafetyVideo,
                  );
                  break;
                case "WALKIN_REGISTARTION":
                  setNdaEnabled(settings.data.walkInRegistrationNDA);
                  setSafetyInstructionEnabled(settings.data.walkInSafetyVideo);
                  break;
                case "SELF_REGISTARTION":
                  setNdaEnabled(settings.data.selfRegistrationNDA);
                  setSafetyInstructionEnabled(
                    settings.data.selfRegistrationSafetyVideo,
                  );
                  break;
                default:
                  setNdaEnabled(false);
                  setSafetyInstructionEnabled(false);
              }
              setProfilePhotoEnable(settings.data.invitationProfilePhoto);
              setProfilePhotoMandatory(
                settings.data.checkInvitationProfilePhoto,
              );
              if (settings.data.dateFormat === "dd-MM-yyyy") {
                setDateFormat("dd-MM-yyyy");
              }
              if (settings.data.dateFormat === "MM-dd-yyyy") {
                setDateFormat("MM-dd-yyyy");
              }
              if (settings.data.dateFormat === "yyyy-MM-dd") {
                setDateFormat("yyyy-MM-dd");
              }
            }
          }
          setPayload({
            id: data.data.visitor.id,
            firstName: data.data.visitor.firstName,
            lastName: data.data.visitor.lastName,
            email: data.data.visitor.email,
            phoneCountryCode: data.data.visitor.phone
              ? data.data.visitor.phone.split("-")[0]
              : undefined,
            phone: data.data.visitor.phone
              ? data.data.visitor.phone.split("-")[1]
              : undefined,
            visitorCompanyName: data.data.visitor.visitorCompanyName,
            hostName: data.data.Visit.hostName,
            visitorId: data.data.Visit.id,
            registrationId: data.data.Visit.id,
            visitMode: data.data.Visit.visitMode,
            scheduledStartDate: CommonUtil.getLocalDateTimeInYearFormat(
              data.data.Visit.scheduledStartDate,
            ),
            scheduledEndDate: CommonUtil.getLocalDateTimeInYearFormat(
              data.data.Visit.scheduledEndDate,
            ),
            profilePhoto: payload.firstName,
            companyId: data.data.Visit.companyId,
          });
          setPhoneInput(data.data.visitor.phone);
          setUploadPic(data.data.Visit.visitMode !== "INVITATION");
          setVisitModeWalk(data.data.Visit.visitMode !== "WALKIN_REGISTARTION");
          setProfile(
            data.data.visitor.profilePhotoURL
              ? data.data.visitor.profilePhotoURL
              : data.data.visitor.profilePhotoURL,
          );
          setProfileImage(
            data.data.visitor.profilePhotoURL
              ? data.data.visitor.profilePhotoURL
              : data.data.visitor.profilePhotoURL,
          );

          setCheckList(data.data.checkListItem);
          setVisitorsId(data.data.Visit.id);
        } else if (
          data.code === "CVSE0061" ||
          data.code === "CVAE0074" ||
          data.data.Visit.status === "APPROVED" ||
          data.data.Visit.status === "REJECTED"
        ) {
          setPayload([]);
          history.push("/vis/result-page");
        }
        if (data.data.Visit.status != "SCHEDULED") {
          setPayload([]);
          history.push("/vis/result-page");
        }
        if (
          data.data.visitor.phone === undefined ||
          data.data.visitor.phone === ""
        ) {
          dispatch(getCompanyById(data.data.Visit.companyId))
            .unwrap()
            .then((data) => {
              if ((data.code = "UASI0026")) {
                const fullCountryName = data.data.country;
                const countryCode = getCountryCodeFromName(fullCountryName);
                if (countryCode) {
                  setPhoneNumberCheck(countryCode);
                } else {
                  setPhoneNumberCheck("us");
                }
              }
            })
            .catch((er) => {});
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const ndaSettings = async (companyId) => {
    try {
      const data = await dispatch(getListSettingsById(companyId)).unwrap();
      if (data.code === "CVAI0000") {
        return data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Failed to load settings", error);
      return null;
    }
  };

  const uploadProfilePhoto = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", data.data.profilePhotoURL);
    bodyFormData.append("file", profileImage);
    httpCommon
      .unsecuredMultipartAxios()
      .post("/web/employee/profile", bodyFormData)
      .then(function(response) {
        // Toast("Profile Photo Saved", "success");
      })
      .catch(function(response) {});
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (profilePhotoMandatory) {
      if (visitModeWalk) {
        if (profileImage === undefined || profileImage === "") {
          Toast(t("Profile Photo is Required"), "error");
          setError({ profilePhoto: true });
          return;
        }
      }
    }

    if (CommonUtil.isEmptyString(payload.firstName)) {
      Toast("Please Enter First Name", "error");
      return;
    }
    if (!CommonUtil.isValidNames(payload.firstName)) {
      Toast("Please Enter Valid First Name ", "error");
      return;
    }

    if (
      payload.scheduledStartDate === null ||
      payload.scheduledStartDate === undefined ||
      payload.scheduledStartDate === ""
    ) {
      Toast(t("INVITATIONFORM011"), "error");
      return;
    }

    if (
      payload.scheduledEndDate === null ||
      payload.scheduledEndDate === undefined ||
      payload.scheduledEndDate === ""
    ) {
      Toast(t("INVITATIONFORM012"), "error");
      return;
    }

    setIsLoading(true);
    dispatch(visitorUpdate(Object.assign(payload)))
      .unwrap()
      .then((res) => {
        if (res.code === "OMSI0236") {
          if (!CommonUtil.isEmptyString(res.data.profilePhotoURL)) {
            uploadProfilePhoto(res);
            setIsLoading(true);
          }
          if (checkList?.questionaries?.length > 0) {
            setIsLoading(true);
            const enabledlistItems = checkList.questionaries.filter(
              (question) => {
                return question.disabled === false;
              },
            );

            if (enabledlistItems.length > 0) {
              history.push({
                pathname: "/vis/check-list-form",
                state: {
                  success: true,
                  listValue: enabledlistItems,
                  id: paramid,
                  code: code,
                  ndaEnabled: ndaEnabled,
                  companyId: companyId,
                  status: status,
                  videoAcknowledgement: safetyInstructionEnabled,
                },
              });
            } else {
              httpCommon
                .securedAxios()
                .put("/web/visit/confirm/" + code)
                .then((res) => {
                  if (res.data.code === "CVAI0072") {
                    history.push({
                      pathname: "/vis/visit-success",
                      state: { message: res.data.message, success: true },
                    });
                  } else {
                    Toast(res.data.message, "error");
                  }
                })
                .catch((e) => {
                  console.log(e);
                });
            }
          } else if (ndaEnabled) {
            history.push({
              pathname: "/vis/VerifyNDA",
              state: {
                id: paramid,
                code: code,
                companyId: companyId,
                videoAcknowledgement: safetyInstructionEnabled,
              },
            });
          } else if (safetyInstructionEnabled) {
            history.push({
              pathname: REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT,
              state: {
                id: paramid,
                code: code,
                companyId: companyId,
              },
            });
          } else {
            setIsLoading(true);
            httpCommon
              .unsecuredAxios()
              .put("/web/visit/confirm/" + code)
              .then((res) => {
                if (res.data.code === "CVAI0072") {
                  history.push({
                    pathname: "/vis/visit-success",
                    state: { message: res.data.message, success: true },
                  });
                } else {
                  Toast(res.data.message, "error");
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        }
      });
    setIsLoading(false).catch((e) => {
      console.log(e);
    });
  };

  async function handleProfile(file) {
    if (file) {
      const formData = new FormData();
      formData.append("visitorImageFile", file.file);
      dispatch(validateVisitorImage(formData)).then((res) => {
        if (!res.payload?.data?.image) {
          Toast(t("FACE_DETECTION_ERROR"), "error");
          setProfile("");
          setProfileImage("");
          setResetTrigger(Date.now());
          return;
        } else {
          setPayload({
            ...payload,
            profilePhoto: payload.firstName,
          });
          setProfile(file.base64);
          setProfileImage(file.file);
        }
      });
    } else {
      setProfile("");
      setProfileImage("");
    }
  }

  const handleCancel = () => {
    httpCommon
      .securedAxios()
      .put("/web/visit/rejectvisit/" + code)
      .then((res) => {
        if (res.data.code === "CVAI0073") {
          history.push({
            pathname: "/vis/reject/visit",
            state: { message: res.data.message, reject: true },
          });
        } else {
          Toast(res.data.message, "error");
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px",
          backgroundColor: "#F4F6F8",
        }}
      >
        <Grid container alignItems="center">
          <Grid item className="logo-center">
            <img src={USA_visLogo} alt="logo" style={{ width: "300px" }} />
          </Grid>
        </Grid>
      </Grid>
      <Paper
        style={{
          height: "calc(100vh - 120px)",
          overflow: "auto",
        }}
      >
        <Typography
          gutterBottom
          variant="h2"
          style={{ padding: "20px", textAlign: "center", color: "#3D4977" }}
        >
          Visitor Details
        </Typography>
        <Grid
          container
          p={5}
          spacing={3}
          style={{
            paddingTop: "0px",
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {profilePhotEnable || uploadpic ? (
              <Grid>
                <ConfirmUploadPhoto
                  onsetProfile={(profile) => handleProfile(profile)}
                  profilePhoto={profile}
                  disabled={uploadpic}
                  confirmProfilePhoto={confirmProfilePhoto}
                  resetTrigger={resetTrigger}
                />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
          <Grid item sm={12} md={8}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <CustomTextfield
                  label={"First Name"}
                  name={"firstName"}
                  value={payload.firstName}
                  required={true}
                  handleChange={handleChange}
                  error={error.firstName}
                  inputProps={{ maxLength: 100 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextfield
                  label={"Last Name"}
                  name={"lastName"}
                  value={payload.lastName}
                  handleChange={handleChange}
                  error={error.lastName}
                  inputProps={{ maxLength: 25 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextfield
                  disabled
                  label={"Email"}
                  name={"email"}
                  value={payload.email}
                  validation="email"
                  handleChange={handleChange}
                  error={error.email}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomPhone1
                  placeholder="Mobile"
                  value={phoneInput}
                  country={phoneNumberCheck}
                  specialLabel={false}
                  handleChange={(value, data, event, formattedValue) =>
                    handlePhoneChange(value, data, event, formattedValue)
                  }
                  disabled
                  inputStyle={inputStyle}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <CustomTextfield
                  disabled
                  label={"Company Name"}
                  name={"visitorCompanyName"}
                  value={payload.visitorCompanyName}
                  handleChange={handleChange}
                  error={error.visitorCompanyName}
                  validation="alpha-numeric"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomTextfield
                  disabled
                  label={"Host (Person to meet)"}
                  name={"hostName"}
                  value={payload.hostName}
                  validation="alpha-numeric"
                  handleChange={handleChange}
                  error={error.hostName}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                {dateFormat === "dd-MM-yyyy" && (
                  <CustomDateTimePicker1
                    onChange={(scheduledStartDate) =>
                      setPayload({
                        ...payload,
                        scheduledStartDate: scheduledStartDate,
                      })
                    }
                    value={payload.scheduledStartDate}
                    label={"Invite Start Date"}
                    date={"dd-MM-yyyy HH:mm"}
                    disabled
                  />
                )}
                {dateFormat === "MM-dd-yyyy" && (
                  <CustomDateTimePicker1
                    onChange={(scheduledStartDate) =>
                      setPayload({
                        ...payload,
                        scheduledStartDate: scheduledStartDate,
                      })
                    }
                    value={payload.scheduledStartDate}
                    label={"Invite Start Date"}
                    date={"MM-dd-yyyy HH:mm"}
                    disabled
                  />
                )}
                {dateFormat === "yyyy-MM-dd" && (
                  <CustomDateTimePicker1
                    onChange={(scheduledStartDate) =>
                      setPayload({
                        ...payload,
                        scheduledStartDate: scheduledStartDate,
                      })
                    }
                    value={payload.scheduledStartDate}
                    label={"Invite Start Date"}
                    date={"yyyy-MM-dd HH:mm"}
                    disabled
                  />
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                {dateFormat === "dd-MM-yyyy" && (
                  <CustomDateTimePicker1
                    onChange={(scheduledEndDate) =>
                      setPayload({
                        ...payload,
                        scheduledEndDate: scheduledEndDate,
                      })
                    }
                    value={payload.scheduledEndDate}
                    minDateTime={payload.scheduledStartDate}
                    label="Invite End Date"
                    date={"dd-MM-yyyy HH:mm"}
                    disabled
                  />
                )}
                {dateFormat === "MM-dd-yyyy" && (
                  <CustomDateTimePicker1
                    onChange={(scheduledEndDate) =>
                      setPayload({
                        ...payload,
                        scheduledEndDate: scheduledEndDate,
                      })
                    }
                    value={payload.scheduledEndDate}
                    minDateTime={payload.scheduledStartDate}
                    label="Invite End Date"
                    date={"MM-dd-yyyy HH:mm"}
                    disabled
                  />
                )}
                {dateFormat === "yyyy-MM-dd" && (
                  <CustomDateTimePicker1
                    onChange={(scheduledEndDate) =>
                      setPayload({
                        ...payload,
                        scheduledEndDate: scheduledEndDate,
                      })
                    }
                    value={payload.scheduledEndDate}
                    minDateTime={payload.scheduledStartDate}
                    label="Invite End Date"
                    date={"yyyy-MM-dd HH:mm"}
                    disabled
                  />
                )}
              </Grid>
              <Grid
                container
                lg={12}
                md={12}
                xs={12}
                spacing={1}
                justifyContent="flex-end"
                sx={{
                  marginTop: "10px",

                  justifyContent: {
                    xs: "center",
                    sm: "center",
                    md: "flex-end",
                    lg: "flex-end",
                    xl: "flex-end",
                  },
                }}
              >
                <Grid item>
                  <CancelButtons
                    color="secondary"
                    onClick={handleCancel}
                    variant="contained"
                  >
                    <Typography>{"Cancel"}</Typography>
                  </CancelButtons>
                </Grid>
                <Grid item>
                  <SubmitButtons
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={isLoading}
                  >
                    <Typography>{"Continue"}</Typography>
                  </SubmitButtons>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}

export default ConfirmVisitV2;
